export const DEFAULT_LOCALE = 'da_DK'
